export default __webpack_public_path__ + "static/966-26c66296601463291b2d401c5582985b.gif";